import { useMutation, useQuery } from "@tanstack/react-query";
import axiosPrivate from "../axiosPrivate";
import axiosPublic from "../axiosPublic";
import { bankTransfer, getMeterServices, liquidationRequest, walletTransfer } from "../../repository/payment";
import { getOrganizationSettings } from "../../utils/storage";

export const useGetBanks = () =>
  useQuery({
    queryKey: ["banks"],
    queryFn: async () => {
      const res = await axiosPublic.get("banks");
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });

export const useVerifyAccount = (accountNumber, bankId) => {
  return useQuery({
    queryKey: ["verifyAccount"],
    queryFn: async () => {
      const res = await axiosPrivate.get(
        `verify/bank-account/${accountNumber}/${bankId}`
      );
      return res.data;
    },
    enabled: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export const useVerifyWalletAccount = (accountNumber) => {

  console.log(accountNumber, "Account number");


  return useQuery({
    queryKey: ["verifyWalletAccount", accountNumber],
    queryFn: async () => {
      const res = await axiosPrivate.get(
        `verify/wallet-number/${accountNumber}`
      );
      return res.data;
    },
    enabled: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });
};

export const useMeterServices = () => {
  return useQuery({
    queryKey: ["meterServices"],
    queryFn: getMeterServices,
    enabled: true,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });
};


// Process Transfer
export async function processTransfer({
  source_wallet_number,
  destination_account_number,
  bank_id,
  amount,
  description,
  transaction_pin,
}) {
  try {
    // @ts-ignore
    const token = localStorage.getItem("token");

    const newOrg = getOrganizationSettings();
    const appid = newOrg.id;


    const response = await axiosPrivate.post(
      "customers/wallet-to-bank-transaction/process",
      bankTransfer,
      {
        // @ts-ignore
        source_wallet_number,
        destination_account_number,
        bank_id,
        amount,
        description,
        transaction_pin,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to process transfer:", error);
    throw error;
  }
}

// Login
export const useBankTransfer = (transferRequest) => {
  console.log(transferRequest, "Transfer Request payload");

  return useMutation({
    mutationFn: bankTransfer,
    onSuccess: (data) => {
      // @ts-ignore
      return data?.data;
    },
    onError: (error) => {
      // @ts-ignore
      console.error("Login failed:", error?.response?.data);

      // @ts-ignore
      return error?.response?.data;
    },
  });
};

// Login
export const useLiquidationRequest = (transferRequest) => {
  console.log(transferRequest, "Transfer Request payload");

  return useMutation({
    mutationFn: liquidationRequest,
    onSuccess: (data) => {
      // @ts-ignore
      return data?.data;
    },
    onError: (error) => {
      // @ts-ignore
      console.error("Login failed:", error?.response?.data);

      // @ts-ignore
      return error?.response?.data;
    },
  });
};

// Login
export const useWalletTransfer = (transferRequest) => {
  console.log(transferRequest, "Transfer Request payload");

  return useMutation({
    mutationFn: walletTransfer,
    onSuccess: (data) => {
      // @ts-ignore
      return data?.data;
    },
    onError: (error) => {
      // @ts-ignore
      console.error("Login failed:", error?.response?.data);

      // @ts-ignore
      return error?.response?.data;
    },
  });
};

export const useGetWalletTransactions = ({
  page = 1,
  items_per_page = 15,
  wallet_number_or_uuid = "",
} = {}) => {
  const params = { page, items_per_page };
  if (wallet_number_or_uuid)
    params.wallet_number_or_uuid = wallet_number_or_uuid;

  return useQuery({
    queryKey: ["walletTransactions", params],
    queryFn: async () => {
      const res = await axiosPrivate.get(`customers/wallet-transactions`);
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};
